import { render, staticRenderFns } from "./TagExistingMentionsDialog.vue?vue&type=template&id=05d1910d&scoped=true"
import script from "./TagExistingMentionsDialog.vue?vue&type=script&lang=js"
export * from "./TagExistingMentionsDialog.vue?vue&type=script&lang=js"
import style0 from "./TagExistingMentionsDialog.vue?vue&type=style&index=0&id=05d1910d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1910d",
  null
  
)

export default component.exports